export const SENTRY_DSN =
    "https://bea4588b052308aeb387cebebba84813@o4511069165584384.ingest.us.sentry.io/4511078749569024";

export type SentryEnvironment =
    | "development"
    | "preview"
    | "staging"
    | "production";

type Environment = Record<string, string | undefined>;

const GIT_SHA = /^[0-9a-f]{40}$/u;

export function sentryEnvironment(
    value: string | undefined,
): SentryEnvironment {
    switch (value?.trim().toLowerCase()) {
        case "production":
        case "prod":
        case "prd":
            return "production";
        case "staging":
        case "stg":
            return "staging";
        case "preview":
            return "preview";
        default:
            return "development";
    }
}

export function resolveSentryEnvironment(env: Environment): SentryEnvironment {
    return sentryEnvironment(
        [
            env.VERCEL_TARGET_ENV,
            env.DEPLOY_ENVIRONMENT,
            env.DATADOG_ENV,
            env.ENVIRONMENT,
        ].find((value) => value?.trim()),
    );
}

export function sentryRelease(value: string | undefined): string | undefined {
    const normalized = value?.trim().toLowerCase();
    return normalized && GIT_SHA.test(normalized) ? normalized : undefined;
}

export function resolveSentryRelease(env: Environment): string | undefined {
    return [
        env.DEPLOY_SOURCE_SHA,
        env.VERCEL_GIT_COMMIT_SHA,
        env.BUILDKITE_COMMIT,
        env.GITHUB_SHA,
    ]
        .map(sentryRelease)
        .find((release) => release !== undefined);
}

export function isSentryEnabled(environment: SentryEnvironment): boolean {
    return environment !== "development";
}

export function sentryRuntimeOptions(
    env: Environment,
    build: { environment?: string; release?: string } = {},
) {
    const environment = build.environment
        ? sentryEnvironment(build.environment)
        : resolveSentryEnvironment(env);
    const release = sentryRelease(build.release) ?? resolveSentryRelease(env);
    return {
        dsn: SENTRY_DSN,
        environment,
        enabled: isSentryEnabled(environment),
        ...(release ? { release } : {}),
    };
}
